<div class="basiq-add-requirement-page">
  <div class="content-wrapper">
    <h2>Manage Your Data Sharing Consent</h2>
    
    <div class="info-container">
      <p>When you connect your bank through Dynamoney, we use Basiq, an accredited CDR intermediary, to securely access your financial data. You maintain complete control over your data sharing and can manage or revoke consent at any time.</p>
    </div>

    <div class="info-section">
      <h3>What you can do</h3>
      <ul>
        <li><strong>View your connections:</strong> See which bank accounts are currently sharing data</li>
        <li><strong>Stop data sharing:</strong> Revoke consent and disconnect your bank accounts at any time</li>
        <li><strong>Update connections:</strong> Add new bank accounts or refresh existing connections</li>
      </ul>
    </div>

    <div class="important-info">
      <h3>Important information</h3>
      <p><strong>Your consent automatically expires after 12 months</strong> unless you choose to renew it. You can withdraw your consent at any time before this expiry date.</p>
      <p>When you revoke consent, Dynamoney will no longer be able to access your banking data through Basiq. However, any data already collected will be retained in accordance with our Privacy Policy.</p>
    </div>

    <div class="form-section">
      <h3>Enter your business name</h3>
      <p class="form-description">To manage your data sharing settings, please enter your business name below.</p>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <business-search 
            [placeholder]="businessSearchPlaceholder" 
            [formControl]="businessDetails"
            [searchFn]="searchBusinessFn">
          </business-search>
        </div>
      </div>
    </div>

    <div class="form-section">
      <h3>Your personal details</h3>
      <p class="form-description">Please provide your details exactly as they appear in your application.</p>
      
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <name title="First Name" [formControl]="givenName"></name>
        </div>
        <div class="col-lg-3 col-md-12">
          <name title="Last Name" [formControl]="surName"></name>
        </div>
      </div>
    </div>

    <!-- OTP Delivery Method -->
    <div class="form-section otp-method-section">
      <h3>Select verification code delivery method</h3>
      <p class="form-description">
        To verify your identity, please select how you would like to receive your One-Time Passcode (OTP).
      </p>
 
      <mat-radio-group
        aria-label="Select OTP delivery method"
        [formControl]="otpDeliveryMethod"
        class="otp-method-options">
        <mat-radio-button value="sms" class="otp-method-option">SMS</mat-radio-button>
        <mat-radio-button value="email" class="otp-method-option">Email</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="action-container">
      <button
        mat-flat-button
        color="primary"
        class="w-lt-md-100"
        (click)="send2FaCodeToBusinessUser()"
        [disabled]="!isFormValid() || isVerifying">
        Send Verification Code
      </button>
    </div>

    <div class="help-section">
      <h3>Need help?</h3>
      <p>If you have questions about data sharing or need assistance, please contact our support team:</p>
      <p><strong>Phone:</strong> 1300 001 420</p>
      <p><strong>Email:</strong> <a href="mailto:support&#64;dynamoney.com"> support&#64;dynamoney.com</a></p>
    </div>

    <div class="footer-container">
      <p>
        For information about how we handle your data, please refer to our
        <a href="/privacy-policy">Privacy Policy</a>
      </p>
    </div>
  </div>
</div>